<template>
  <div></div>
</template>

<script>
export default {
    data(){
        this.$router.replace('/supplierAllBack')
    }
}

</script>
<style>
</style>